module.exports = __webpack_public_path__ + "img/Kibe15.bc30eb68.png";